import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { BannerContainer } from './BannerGatsbyImg.styled';

const BannerGatsbyImg = ({ image, title, playbookNewsletter }) => {
  return (
    <BannerContainer playbookNewsletter={playbookNewsletter}>
      <GatsbyImage
        image={getImage(image)}
        width='100%'
        height='350'
        alt={title}
        loading='eager'
      />
      <h1 className='banner_title'>{title}</h1>
    </BannerContainer>
  );
};

export default BannerGatsbyImg;
